import { render, staticRenderFns } from "./NurseRegistrationTypeModal.vue?vue&type=template&id=070870b0"
import script from "./NurseRegistrationTypeModal.vue?vue&type=script&lang=js"
export * from "./NurseRegistrationTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports